import { isDev } from "../functions";

export const logger = console;

// Don't accept log calls in production environment
if (!isDev()) {
    logger.log = () => ({});
}
